import React from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { useI18n, useSelector } from '~Hooks';
import styled from '@emotion/styled';
import Modal from '~ComponentsImproved/Modal';
import Heading from '~ComponentsImproved/Typography/Heading';
import { getCompanyData_Company_courseTypes } from './__queries__';
import CourseButton from './CourseButton';
import { handyBreakpoint } from '~Styles/breakpoints';

export type CourseType = getCompanyData_Company_courseTypes;

const Content = styled.div`
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 0px 12px rgb(0 0 0 / 20%), 0px 20px 32px rgb(0 0 0 / 20%),
    0px 0px 40px rgb(0 0 0 / 16%);
  padding: 48px 56px;
  width: 400px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  ${handyBreakpoint} {
    width: 100%;
    padding: 24px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
`;

const GET_COURSE_TYPES = gql`
  query getCompanyData($companyId: ID!) {
    Company(id: $companyId) {
      id
      courseTypes {
        id
        label
        name
        color
        order
      }
    }
  }
`;

interface Props {
  onClose: () => void;
  onChange: (value: CourseType) => void;
}

const TypeChanger = ({ onClose, onChange }: Props) => {
  const companyId = useSelector((state) => state.company);
  const { data } = useQuery(GET_COURSE_TYPES, {
    variables: { companyId },
  });
  const { i18n } = useI18n();

  const types = data?.Company?.courseTypes ?? [];
  const sortedTypes = [...types]?.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return (
    <Modal isShowing={sortedTypes.length > 0} hide={onClose}>
      <Content>
        <Heading level={3} bottom={28}>
          {`${i18n('TSR.ChooseCourseType')}:`}
        </Heading>
        <ButtonWrapper>
          {sortedTypes.map((type: CourseType, i: number) => (
            <CourseButton key={i} courseType={type} onChange={() => onChange(type)} />
          ))}
        </ButtonWrapper>
      </Content>
    </Modal>
  );
};

export default TypeChanger;
